import { render, staticRenderFns } from "./MainTowerCard.vue?vue&type=template&id=6da3b942&scoped=true&"
import script from "./MainTowerCard.vue?vue&type=script&lang=js&"
export * from "./MainTowerCard.vue?vue&type=script&lang=js&"
import style0 from "./MainTowerCard.vue?vue&type=style&index=0&id=6da3b942&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da3b942",
  null
  
)

export default component.exports